<template>
	<CloHero color="primary">
		<template #text>
			<div class="Report-heading-main" :class="!isPrintLayout ? 'u-color-vars-reverse' : ''">
				<!-- Title -->
				<ReportTitle
					:tripId="tripReportModelData.tripReportId"
					:tripName="tripReportModelData.name"
					:tripBeginDt="tripReportModelData.beginDt"
					:tripEndDt="tripReportModelData.endDt"
					:privacySetting="tripReportModelData.privacy"
					:locale="locale"
					:reverse="!isPrintLayout"
					:inline="isPrintLayout"
				/>
				<!-- Regions (shown for medium up) -->
				<div v-if="Object.keys(tripReportModelData.regions).length > 0 && !isPrintLayout" class="u-showForMedium">
					<CloHeading class="is-visuallyHidden" level="3">{{ $t('generic.Regions') }}</CloHeading>
					<ReportMetaRegions :regions="tripReportModelData.regions" :compact="true" />
				</div>
				<!-- People (shown for medium up) -->
				<div v-if="!isPrintLayout" class="u-showForMedium">
					<CloHeading class="is-visuallyHidden" level="3">{{ $t('tripReport.people') }}</CloHeading>
					<ReportMetaPeople :confirmedPeople="confirmedPeople" />
				</div>
				<!-- Share and edit buttons -->
				<ReportMetaTools
					v-if="!isPrintLayout"
					:currentUser="currentUser"
					:privacySetting="tripReportModelData.privacy"
					:tripId="tripReportModelData.tripReportId"
					:comments="comments"
					:narrative="narrative"
					:hasInvitedPeople="tripReportModelData.people.length > 1"
				/>
			</div>
		</template>
		<template #image>
			<CloHeading class="is-visuallyHidden" level="3">{{ $t('tripReport.checklistsMap') }}</CloHeading>
			<ReportMap :tripId="tripReportModelData.tripReportId" />
		</template>
	</CloHero>
</template>

<script>
import CloHero from './CloHero.vue';
import ReportTitle from './ReportTitle.vue';
import ReportMetaPeople from './ReportMetaPeople.vue';
import ReportMetaTools from './ReportMetaTools.vue';
import ReportMap from './ReportMap.vue';
import ReportMetaRegions from './ReportMetaRegions.vue';
import CloHeading from '@/base/CloHeading/CloHeading.vue';
import CloImageAspectRatio from '@/media/CloImageAspectRatio/CloImageAspectRatio.vue';
import CloButton from '@/base/CloButton/CloButton.vue';
export default {
	name: 'ReportHeading',
	components: {
		CloHero,
		CloHeading,
		CloImageAspectRatio,
		ReportTitle,
		ReportMetaPeople,
		ReportMetaRegions,
		ReportMetaTools,
		ReportMap,
		CloButton,
	},
	props: {
		tripName: String,
		tripBeginDt: String,
		tripEndDt: String,
		privacySetting: String,
		locale: String,
		currentUser: Object,
		confirmedPeople: Array,
		isPrintLayout: Boolean,
		comments: {
			type: Array,
			required: true,
		},
		narrative: String,
	},
	data() {
		return {
			tripReportModelData: window.tripReport,
		};
	},
};
</script>

<style lang="scss">
.Report-heading-main {
	display: flex;
	gap: $space-sm;
	.ReportTitle {
		flex: 1 1 auto;
	}
	.ReportMetaTools {
		flex: 0 0 auto;
	}
	@include breakpoint(medium) {
		flex-direction: column;
		gap: $space-sm;
		> * {
			flex: 0 1 auto;
		}
	}
	@include breakpoint(large) {
		gap: $space-md;
	}
}

.print {
	.Report-heading-main {
		gap: $space-sm;
	}
}
</style>
